import { render, staticRenderFns } from "./ok.vue?vue&type=template&id=137f8402&scoped=true&"
var script = {}
import style0 from "./ok.vue?vue&type=style&index=0&id=137f8402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f8402",
  null
  
)

export default component.exports